// Returns a stable per-browser device identifier, generating one on first use.
// Stored in localStorage so it persists across sessions for this browser
// instance. Used only to group trusted-device rows server-side — it is NOT
// a security token (the device trust token remains the security boundary).
export function getDeviceId() {
  let id = localStorage.getItem('device_id');
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) ||
         `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem('device_id', id);
  }
  return id;
}